import React, {Component} from 'react';
import {Button, CardContent, Divider, Grid, Paper, Typography} from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import {Link} from 'react-router-dom';
import {withTranslation} from "react-i18next";
import dartopolis from '../../DartopolisClient';
import {formatDistance, format, parse} from 'date-fns';
import {cs, de, enGB} from 'date-fns/locale';
import {connect} from "react-redux";
import EmojiEventsIcon  from '@material-ui/icons/EmojiEvents';

const style = (theme) => {
    return {
        root: {
            minWidth: 240,
            width: 350,
            padding: theme.spacing(2)
        },
        regEndsMessage: {
            paddingTop: 8
        },
        regEndsCounter: {
            color: "#00a000"
        },
        regEndsCounterRed: {
            color: "#a00000"
        },
        media: {
            height: 100
        },
        imageDiv: {
            width: "100%",
            height: 110
        },
        panelDiv: {
            padding: theme.spacing(2, 0, 2, 0)
        },
        actionButtons: {
            paddingRight: theme.spacing(1.5)
        },
        divider: {
            margin: theme.spacing(0, 0, 1, 0)
        }
    };
};

class InfoPanel extends Component {
    state = {
        localStartMS: null,
        remainingTimeMS: null,
        numInvocations: 0
    };

    checkRegistrationTimeRemaining() {
        if (!this.props.instance) {
            return;
        }

        const cnt = this.state.numInvocations;
        if (cnt > 0 && cnt % 600 === 15) {
            dartopolis.getRemainingTimeToRegister(this.props.instance.id, (regRemaining) => {
                this.setState({
                    remainingTimeMS: regRemaining.remainingTimeToRegisterMS,
                    localStartMS: Date.now()
                });
            });
        }

        this.setState({
            numInvocations: cnt + 1
        });
    };

    componentDidMount() {
        setTimeout(() => {
            this.interval = setInterval(() => {
                this.checkRegistrationTimeRemaining();
            }, 1000);
        }, 10000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        this.interval = null;
    }

    registrationEndsMessage = () => {
        const {remainingTimeMS, localStartMS} = this.state;
        const {classes} = this.props;
        if (remainingTimeMS === null || localStartMS === null) {
            return null;
        }

        const now = Date.now();
        const elapsed = now - localStartMS;
        let remaining = (remainingTimeMS - elapsed) / 1000;
        if (remaining <= 0) {
            // return <Typography variant="body1" color="textPrimary" className={classes.regEndsMessage}>{t('registrationForm.registrationEnded')}</Typography>;
            return null;
        }
        const counterClassName = remaining < 1800 ? classes.regEndsCounterRed : classes.regEndsCounter;

        const locale = this.currentLocale();
        const formattedMsg = formatDistance(now, new Date(now + remainingTimeMS - elapsed), {locale: locale});

        // return <Typography variant="body1" color="textPrimary" className={classes.regEndsMessage}>{t("landing.registrationEndsCountdown")}: <span className={counterClassName}>{formattedMsg}</span></Typography>;
        return {
            formattedMsg,
            counterClassName
        };
    };


    currentLocale() {
        let locale = enGB;
        if (this.props.language) {
            switch (this.props.language) {
                case 'cs':
                    locale = cs;
                    break;
                case 'de':
                    locale = de;
                    break;
                default:
                    break;
            }
        }

        return locale;
    }


    render() {
        const {t, classes, instance} = this.props;
        const regLabel = t('registrationForm.title');
        const playersListLabel = t('playersList.title');

        const regEndsMessage = this.registrationEndsMessage();


        let contents = null;
        let actions = null;
        if (instance) {
            const fmt = 'yyyy-MM-dd';
            const tstart = parse(instance.tournamentStartDate, fmt, new Date());
            const tend = parse(instance.tournamentEndDate, fmt, new Date());
            const locale = this.currentLocale();
            const regDates = format(tstart, "PPP", {locale: locale}) + " - " + format(tend, "PPP",{locale: locale});
            const registrationEnds = [];
            if (regEndsMessage) {
                registrationEnds.push(<Divider variant="middle" className={classes.divider} key="fmt0"/>);
                registrationEnds.push(<Typography key="fmt1" variant="body1" color="textPrimary">{t("landing.registrationEndsCountdown")}: <span className={regEndsMessage.counterClassName}>{regEndsMessage.formattedMsg}</span></Typography>);
            }

            let numIcons = 0;
            let iconColor = '';
            let wdfRankText = '';
            switch (instance.wdfRank) {
                case 'GOLD':
                    iconColor = 'gold';
                    numIcons = 3;
                    wdfRankText = 'Gold';
                    break;
                case 'SILVER':
                    iconColor = 'silver';
                    numIcons = 2;
                    wdfRankText = 'Silver';
                    break;
                case 'BRONZE':
                    iconColor = 'darkgoldenrod';
                    numIcons = 1;
                    wdfRankText = 'Bronze';
                    break;
                default:
                    break;
            }
            const wdfRankIcons = [];
            const style = {
                color: iconColor,
                verticalAlign: 'text-bottom'
            };
            for (let i = 0; i < numIcons; i++) {
                wdfRankIcons.push(<EmojiEventsIcon key={"emicon" + i} style={style} />);
            }

            contents = (
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="h5" color="textPrimary">{instance.name}</Typography>
                    </Grid>
                    <Grid item xs={4}><Typography variant="body1" color="textPrimary">WDF Rank:</Typography></Grid>
                    <Grid item xs={8}><Typography variant="body1" color="textPrimary">{wdfRankIcons}{wdfRankText}</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body1" color="textPrimary">Dates:</Typography></Grid>
                    <Grid item xs={8}><Typography variant="body1" color="textPrimary">{regDates}</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body1" color="textPrimary">Venue:</Typography></Grid>
                    <Grid item xs={8}>
                        <Button size="small" color="primary" href="http://czechopen.czechdarts.org/venue">Hotel Pyramida</Button>
                    </Grid>
                    <Grid item xs={12}><Typography variant="subtitle2" color="textPrimary">Bělohorská 24, Praha 6, Czech Republic</Typography></Grid>
                </Grid>
            );
            actions = (
                <>
                    <div className={classes.panelDiv}>
                        <Button className={classes.actionButtons} size="small" color="primary" component={Link} to={process.env.REACT_APP_PREFIX + "/registration"}>{regLabel}</Button>
                        <Button className={classes.actionButtons} size="small" color="primary" component={Link} to={process.env.REACT_APP_PREFIX + "/players-list"}>{playersListLabel}</Button>
                    </div>
                    {registrationEnds}
                </>
            );
        } else {
            contents = (
                <CardContent>
                    <Typography variant="h5" color="textPrimary">Czech Open</Typography>
                    <Typography variant="body1" color="textSecondary">Loading...</Typography>
                </CardContent>
            )
        }

        return (
            <Paper className={classes.root}>
                <div className={classes.imageDiv}>
                    <img
                        src={process.env.REACT_APP_PREFIX + "/images/cso.png"}
                        style={{
                            height: 100,
                            width: 88,
                            margin: "5px 0px 0px 10px",
                            float: "left"
                        }}
                        alt="Czech Darts Organization"
                    />
                    &nbsp;
                    <img
                        src={process.env.REACT_APP_PREFIX + "/images/WDF-Colour-R-600x552.png"}
                        style={{
                            height: 100,
                            width: 109,
                            margin: "5px 10px 0px 10px",
                            float: "right"
                        }}
                        alt="World Darts Federation"
                    />
                </div>
                {contents}
                {actions}
            </Paper>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        instance: state.root.currentInstance
    };
}

const mapDispatchToProps = (dispatch) => {
    return {};
}

export default  withStyles(style)(withTranslation('messages')(connect(mapStateToProps, mapDispatchToProps)(InfoPanel)));
